export const BOZ_MESSAGES = {
  LINK: "Please visit our\n" +
        "Website: https://www.bozapp.in\n" +
        "App: https://www.bozpro.in\n" +
        "for booking and more details.",

  "OFFICE ADDRESS": "Boz Office Location:\n" +
                    "Hustlehub Tech Park, 36/5, Somasundarapalya Main Rd, adjacent 27th Main Road, " +
                    "ITI Layout, HSR Layout, Bengaluru, Karnataka 560102\n\n" +
                    "https://maps.app.goo.gl/WMGEsPphqUEEDWxA8",

  INSTAGRAM: "Please visit our\n" +
             "Instagram Page: https://www.instagram.com/boz.app\n" +
             "for past trip photos/videos and more details.",

  "WHATSAPP MESSAGE": "We'll create a whatsapp group a day before the trip!\n" +
                      "And there we will share all the required details about trip coordinator, pickup locations, " +
                      "exact timings, things to carry, live location of bus, etc!",

  "UPCOMING TRIPS": "Our upcoming trips:\n" +
                  "*One Day*:\n"+
                    "1. Lepakshi Temple & Adiyogi Laser Show - ₹1299 \nhttps://www.bozapp.in/trips/lepakshi-temple-adiyogi-one-day-trip-from-bangalore\n\n" +
                    "2. Kotilingeshwara Temple- ₹1299 \nhttps://www.bozapp.in/trips/kotilingeshwara-temple-one-day-trip-from-bangalore\n\n" +
                    "3. Dd Hills & Mandaragiri Hills - ₹1299 \nhttps://www.bozapp.in/trips/dd-hills-mandaragiri-hills-one-day-trip-from-bangalore\n\n" +
                    "4. Hogenakkal - ₹1299 \nhttps://www.bozapp.in/trips/hogenakkal-falls-one-day-trip-from-bangalore\n\n" +
                   "*Two Days*:\n" +
                    "5. Coorg - ₹3999 \nhttps://www.bozapp.in/trips/coorg-2-days-trip-from-bangalore\n\n" +
                    "6. Chikmagalur - ₹4499 \nhttps://www.bozapp.in/trips/chikmagalur-2-days-trip-from-bangalore\n\n" +
                    "7. Ooty - ₹5999 \nhttps://www.bozapp.in/trips/ooty-2-days-trip-from-bangalore\n\n" +
                    "8. Kodaikanal - ₹5499 \nhttps://www.bozapp.in/trips/kodaikanal-2-days-trip-from-bangalore\n\n" +
                    "9. Wayanad - ₹4999 \nhttps://www.bozapp.in/trips/wayanad-2-days-trip-from-bangalore\n\n" +
                    "10. Gokarna - ₹4999 \nhttps://www.bozapp.in/trips/gokarna-2-days-trip-from-bangalore\n\n",

  DISCOUNTS: "Our discount coupons \n" +
             "- *EARLYBIRD15* : 15% off only for the first 4 customers \n" +
             "- *COUPLES10* - 10% off for 2 members \n" +
             "- *GROUP4* - 13% off for 4 memebers\n" +
             "- *GROUP6* - 15% off for 6 members or more\n\n" +
             "You can apply available discount coupons on our Website/App Checkout page. Please click on *Apply Coupons* available coupons will come."
} as const;

export type BozMessageKey = keyof typeof BOZ_MESSAGES;
